import debug from 'bows';
import Clipboard from './_clipboard';
import { slideDown, slideUp } from './_animate';

const log = debug('citation');

export default class {
	constructor( node, opts ) {
		this.node = node;
		this.opts = Object.assign({
			content: '.citation__content',
			openClass: 'citation--open',
			loadingClass: 'citation--loading',
			errorMsg: 'Sorry, there was an error fetching that citation format. Please try a different one.',
			buttonText: 'Copy',
			localStorageKey: 'citationFormat',
			hidden: true
		}, opts);

		this.format = null;
		this.opened = false;
		this.content = this.node.querySelector(this.opts.content);

		if ( this.opts.hidden ) {
			// this.node.style.display = 'none';
		}

		if ( this.opts.buttonText !== false ) {
			let copyP = document.createElement('p');
			this.copy = document.createElement('button');
			this.copy.type = 'button';
			this.copy.setAttribute('data-clipboard-target', this.opts.content);
			this.copy.insertAdjacentHTML('afterbegin', '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M18.984 21v-14.016h-10.969v14.016h10.969zM18.984 5.016c1.078 0 2.016 0.891 2.016 1.969v14.016c0 1.078-0.938 2.016-2.016 2.016h-10.969c-1.078 0-2.016-0.938-2.016-2.016v-14.016c0-1.078 0.938-1.969 2.016-1.969h10.969zM15.984 0.984v2.016h-12v14.016h-1.969v-14.016c0-1.078 0.891-2.016 1.969-2.016h12z"></path></svg>');
			this.copy.insertAdjacentHTML('beforeend', this.opts.buttonText);
			this.copy.className = 'citation__copy button';
			copyP.appendChild(this.copy);
			this.content.parentNode.appendChild(copyP);
			this.clipboard = new Clipboard(`.citation__copy`);
		}

		this.loadingIcon = document.createElement('i');
		this.loadingIcon.insertAdjacentHTML('afterbegin', '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M32 16c-0.040-2.089-0.493-4.172-1.331-6.077-0.834-1.906-2.046-3.633-3.533-5.060-1.486-1.428-3.248-2.557-5.156-3.302-1.906-0.748-3.956-1.105-5.981-1.061-2.025 0.040-4.042 0.48-5.885 1.292-1.845 0.809-3.517 1.983-4.898 3.424s-2.474 3.147-3.193 4.994c-0.722 1.846-1.067 3.829-1.023 5.79 0.040 1.961 0.468 3.911 1.254 5.694 0.784 1.784 1.921 3.401 3.316 4.736 1.394 1.336 3.046 2.391 4.832 3.085 1.785 0.697 3.701 1.028 5.598 0.985 1.897-0.040 3.78-0.455 5.502-1.216 1.723-0.759 3.285-1.859 4.574-3.208 1.29-1.348 2.308-2.945 2.977-4.67 0.407-1.046 0.684-2.137 0.829-3.244 0.039 0.002 0.078 0.004 0.118 0.004 1.105 0 2-0.895 2-2 0-0.056-0.003-0.112-0.007-0.167h0.007zM28.822 21.311c-0.733 1.663-1.796 3.169-3.099 4.412s-2.844 2.225-4.508 2.868c-1.663 0.646-3.447 0.952-5.215 0.909-1.769-0.041-3.519-0.429-5.119-1.14-1.602-0.708-3.053-1.734-4.25-2.991s-2.141-2.743-2.76-4.346c-0.621-1.603-0.913-3.319-0.871-5.024 0.041-1.705 0.417-3.388 1.102-4.928 0.683-1.541 1.672-2.937 2.883-4.088s2.642-2.058 4.184-2.652c1.542-0.596 3.192-0.875 4.832-0.833 1.641 0.041 3.257 0.404 4.736 1.064 1.48 0.658 2.82 1.609 3.926 2.774s1.975 2.54 2.543 4.021c0.57 1.481 0.837 3.064 0.794 4.641h0.007c-0.005 0.055-0.007 0.11-0.007 0.167 0 1.032 0.781 1.88 1.784 1.988-0.195 1.088-0.517 2.151-0.962 3.156z"></path></svg>');
		this.loadingIcon.className = 'citation__loading';

		this.select = this.node.querySelector('select');
		this.post_id = this.select.getAttribute('data-post-id');

		let localStorageFormat = localStorage.getItem(this.opts.localStorageKey);
		if ( localStorageFormat ) {
			this.select.value = localStorageFormat;
		}

		this.select.addEventListener('change', () => {
			log('change', this.select.value );
			this.request( this.select.value );
		});
	}

	close() {
		this.opened = false;
		this.node.dispatchEvent( new CustomEvent( 'citation.close' ) );
		slideUp( this.node, () => this.node.classList.remove( this.opts.openClass ) );
		log('close');
	}

	open() {
		this.opened = true;
		this.node.dispatchEvent( new CustomEvent( 'citation.open' ) );
		slideDown( this.node, () => this.node.classList.add( this.opts.openClass ) );

		if ( ! this.format ) {
			this.request( this.select.value );
		}
		log('open');
	}

	toggle() {
		return this.opened ? this.close() : this.open();
	}

	request( format ) {
		this.prepare();
		this.format = format;
		localStorage.setItem(this.opts.localStorageKey, format);

		if ( this.data ) {
			if ( this.data[ format ] ) {
				this.complete( this.data[ format ] );
			} else {
				this.complete( this.opts.errorMsg );
			}
		} else {
			fetch( `/wp-json/jod/v1/citations/${this.post_id}` ).then((response) => {
				if ( ! response.ok ) {
					throw new Error('Invalid response');
				}

				return response.json()
			} ).then( data => {
				this.data = data;

				log( data, format, data[ format ] );
				if ( ! this.data[ format ] ) {
					throw new Error( 'Format not included' );
				}

				this.complete( this.data[ format ] );

				log(this.opts.loadingClass);
			} ).catch((err) => {
				log('err', err);
				this.complete(this.opts.errorMsg);
			} );
		}
	}

	prepare() {
		this.node.appendChild(this.loadingIcon);
		this.node.classList.add(this.opts.loadingClass);
		this.select.setAttribute('disabled', 'disabled');
	}

	complete( msg = '' ) {
		this.select.removeAttribute('disabled');
		this.node.classList.remove(this.opts.loadingClass);
		this.loadingIcon.parentNode.removeChild(this.loadingIcon);
		this.select.focus();
		this.content.innerHTML = msg;
	}
}
